<template>
  <div style="width:100%">
    <Loading :value="loading"></Loading>
    <h4 mt-2>LISTES DES RESERVES TRAVAUX</h4>
    <v-divider></v-divider>
    <v-layout wrap mt-3>
        <v-flex xs12 >
        <v-layout row class="mb-4 mt-1">
           <v-flex md4 class="mr-1">
                    <el-select @clear="clearSelect()" clearable filterable v-on:change="loadChantier()" v-model="projetS" placeholder="Selectionner de Projet" style="width:100%">
                        <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id">
                        </el-option>
                    </el-select>
            </v-flex>


            <!-- <v-flex md4 class="mr-1">
              <el-select   filterable  @change="filtrerChantier()" v-model="chantierS" placeholder="Selectionner un Chantier" style="width:100%">
                  <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                  </el-option>
              </el-select>
            </v-flex> -->

            <!-- <v-flex md4 class="mr-1">
                    <el-select @clear="clearSelect()" clearable filterable v-on:change="loadChantier()" v-model="projetS" placeholder="Selectionner de Projet" style="width:100%">
                        <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id">
                        </el-option>
                    </el-select>
            </v-flex>


            <v-flex md4 class="mr-1">
              <el-select   filterable   @clear="clearSelect()" @change="filtrerChantier()" v-model="chantierS" placeholder="Selectionner un Chantier" style="width:100%">
                  <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                  </el-option>
              </el-select>
            </v-flex> -->

        </v-layout>

      </v-flex>
      <v-flex xs12>
        <v-layout row class="mb-4 mt-1">
          <v-flex md4 class="mr-1">
            <el-select
              @clear="clearSelect()"
              clearable
              filterable
              @change="filtrerEtat()"
              v-model="etatRes"
              placeholder="Selectionner un etat"
              style="width:100%"
            >
              <el-option
                v-for="(item, index) in listeEtatReserve"
                :key="index"
                :label="item.libelle"
                :value="item.value"
              ></el-option>
            </el-select>
          </v-flex>

           <v-flex offset-xs6 xs2 class="text-xs-right">

              <v-btn

                  outline
                  fab
                  small
                  color="indigo"
                  @click="$emit('reloadListeReserve')"
                >
                  <v-icon>cached</v-icon>
                </v-btn>


          </v-flex>

        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout row mt-3>
      <v-flex xs12>
        <data-tables  ref="multipleTable" @selection-change="handleSelectionChange" :data="listeReserves" style="width:99%;">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="8">
                  <div class="grid-content bg-purple">
                    <h2 class="mb-2">Commentaires:</h2>
                    <div class="mb-2" v-for="(com, i) in scope.row.commentaires" :key="i">
                      <h3>Initiateur: {{com.initiateur}}</h3>
                      <h4>Date: {{com.dateCom}}</h4>
                      <h4>Description:</h4>
                      <div>{{com.description}}</div>
                    </div>
                  </div>
                </el-col>

                <el-col :span="14">
                  <h2 class="mb-2">Photos:</h2>
                  <p>
                    <span v-for="(photo, index) in scope.row.photos" :key="index">
                      <v-avatar
                        class="mr-2"
                        :tile="true"
                        size="140px"
                        height="120px"
                        color="grey lighten-4"
                      >
                        <img :src="photo" alt="avatar" />
                      </v-avatar>
                    </span>
                  </p>
                </el-col>
              </el-row>
            </template>
          </el-table-column>

          <el-table-column prop="idReserve" label="RESERVE" sortable>
            <template slot-scope="scope">R-{{scope.row.idReserve}}</template>
          </el-table-column>
          <el-table-column prop="dateC" label="DATE" sortable></el-table-column>
          <el-table-column prop="libTache" label="TACHE"></el-table-column>
          <el-table-column prop="libEtatRes" label="ETAT"></el-table-column>
          <el-table-column prop="initiateur" label="INITIATEUR"></el-table-column>
          <el-table-column prop="validateur" label="VALIDATEUR"></el-table-column>

          <el-table-column prop="cout" label="MONTANT"></el-table-column>
          <el-table-column prop="dureeRetard" label="DUREE RETARD (J)"></el-table-column>
          <el-table-column label="ACTION" align="center" width="200" fixed="right">
            <template slot-scope="scope">
              <v-tooltip top>
                <v-btn
                  v-if="type== 0 && scope.row.etatReserve == 0"
                  slot="activator"
                  @click="reserveSelect = scope.row;idReserve = scope.row.idReserve; resetForm('formFinTrx') ;dialogValidReserve = true"
                  fab
                  dark
                  small
                  color="blue"
                >
                  <v-icon dark>list</v-icon>
                </v-btn>Confirmer
              </v-tooltip>

              <!-- <v-tooltip bottom>
                <v-btn
                  slot="activator"
                  @click=" etatReserve = scope.row.etatReserve;loadDetailReserve(scope.row.idReserve)"
                  fab
                  dark
                  small
                  color="blue"
                >
                  <v-icon dark>refresh</v-icon>
                </v-btn>Detail reserve
              </v-tooltip> -->

              <v-tooltip top>
                <v-btn

                  v-if=" type != 0 &&  scope.row.etatReserve == 1"

                  slot="activator"
                  fab
                  dark
                  small
                  color="orange"
                  @click="dialogValidChefProjetReserve = true; idReserve = scope.row.idReserve"
                >
                  <v-icon>done</v-icon>
                </v-btn>
                <span>Valider les travaux de reserve(Chef projet)</span>
              </v-tooltip>

               <v-tooltip top>
                <v-btn

                  v-if=" type != 0 &&  scope.row.etatReserve == 1"

                  slot="activator"
                  fab
                  dark
                  small
                  color="red"
                  @click="dialogRefusReserve = true;idReserve = scope.row.idReserve; reserveSelect = scope.row"
                >
                  <v-icon>cached</v-icon>
                </v-btn>
                <span>Refuser les travaux de reserves</span>
              </v-tooltip>


            </template>
          </el-table-column>
        </data-tables>
      </v-flex>
    </v-layout>

    <!-- DETAIL TACHE RESERVE -->
    <v-dialog
      v-model="dialogReserveTache"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      scrollable
    >
      <v-card tile>
        <v-toolbar card dark color="primary">
          <v-toolbar-title>DETAIL RESERVE N {{idReserve}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click.native="dialogReserveTache = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 mt-2 class="elevation-2 pt-2 pl-2 pr-2">
              <data-tables :data="detailReserve" style="width: 100%">
                <el-table-column type="expand">
                  <template slot-scope="scope">
                    <p>
                      <b>Description</b>
                      : {{ scope.row.comment }}
                    </p>
                    <p>
                      <b>Photos</b>
                    </p>
                    <p>
                      <span v-for="(photo, index) in scope.row.photos" :key="index">
                        <v-avatar
                          class="mr-2"
                          :tile="true"
                          size="140px"
                          height="120px"
                          color="grey lighten-4"
                        >
                          <img :src="photo" alt="avatar" />
                        </v-avatar>
                      </span>
                    </p>
                  </template>
                </el-table-column>
                <el-table-column prop="libTache" label="Tache" sortable></el-table-column>
                <el-table-column prop="libEtatTache" label="ETAT"></el-table-column>
                <el-table-column prop="dateF" label="Date fin"></el-table-column>
                <el-table-column label="Action" align="center" fixed="right">
                  <template slot-scope="scope">
                    <v-tooltip top>
                      <v-btn
                        v-if="scope.row.libEtatTache != 'Terminé'"
                        slot="activator"
                        @click="tacheSelect = scope.row;dialogValidReserve = true"
                        fab
                        dark
                        small
                        color="blue"
                      >
                        <v-icon dark>list</v-icon>
                      </v-btn>Confirmer
                    </v-tooltip>

                    <v-tooltip top>
                      <v-btn
                        class="mb-5 ml-5"
                        v-if="scope.row.etatTacheJournal == 1"
                        slot="activator"
                        dark
                        fab
                        large
                        bottom
                        right
                        color="green"
                        @click="valideReserve()"
                      >
                        <v-icon>done</v-icon>
                      </v-btn>
                      <span>Valider les travaux de reserve(Chef chantier)</span>
                    </v-tooltip>
                  </template>
                </el-table-column>
              </data-tables>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-tooltip top>
        <v-btn
          class="mb-5 ml-5"
          v-if=" type == 2 && etatReserve == 2"
          absolute
          slot="activator"
          dark
          fab
          large
          bottom
          right
          color="orange"
          @click="dialogValidChefProjetReserve = true"
        >
          <v-icon>done</v-icon>
        </v-btn>
        <span>Valider les travaux de reserve(Chef projet)</span>
      </v-tooltip>
    </v-dialog>
    <!-- DETAIL TACHE RESERVE -->

    <!--  MODAL CONFORMATION TRAVAUX TACHE RESERVE -->
    <v-dialog v-model="dialogValidReserve" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">Travaux de {{reserveSelect.libTache}}</v-card-title>
        <v-card-text>
          En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.
          <v-flex xs12>
            <el-form ref="formFinTrx"  label-position="top" :inline="true" class="demo-form-inline">
              <v-layout wrap>
                <v-flex xs12>
                  <el-form-item label="Commentaire" style="width:100%">
                    <el-input
                      type="textarea"
                      :rows="4"
                      id="commentaire"
                      placeholder="Commentaire"
                      v-model="formFinTrx.com"
                      style="width:100%"
                    ></el-input>
                  </el-form-item>
                </v-flex>
              </v-layout>
              <v-flex md3>
                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                  <img :src="imageTrx" alt="avatar" />
                </v-avatar>
                <v-layout row>
                  <input
                    name="fileTache"
                    type="file"
                    style="display:none"
                    ref="fileTache"
                    accept="image/*"
                    @change="onFileTachePicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileTache.click()"
                  >
                    Image Travaux
                    <v-icon right dark>cloud_upload</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </el-form>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click.native="dialogValidReserve = false"
          >Annuler</v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            :disabled="!formFinTrx.com"
            @click.native="validerTacheRapport()"
          >Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  MODAL CONFORMATION TRAVAUX TACHE RESERVE-->

    <!--   MODAL CONFORMATION CHEF PROJET RESERVE -->
    <v-dialog v-model="dialogValidChefProjetReserve" max-width="500">
      <v-card>
        <v-card-title class="headline">VALIDATION TRAVAUX DE RESERVES</v-card-title>
        <v-card-text>
          En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.
          <p>
            <b>NB: Veuillez préciser le coût des travaux ainsi que la durée de retard sur le planning s'il vous plaît puis valider.</b>
          </p>
          <v-flex xs12>
            <el-form label-position="top" :inline="true" class="demo-form-inline">
              <v-flex xs12>
                <el-form-item label="Coût" prop="cout" width="100%">
                  <el-input-number
                    width="100%"
                    :min="0"
                    size="large"
                    controls-position="right"
                    v-model="coutReserve"
                    placeholder="coût"
                  ></el-input-number>
                </el-form-item>
                <el-form-item label="Durée de retard (Jours)" prop="durée" width="100%">
                  <el-input-number
                    width="100%"
                    :min="0"
                    size="large"
                    controls-position="right"
                    v-model="dureeReserve"
                    placeholder="durée"
                  ></el-input-number>
                </el-form-item>
              </v-flex>
            </el-form>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click.native="dialogValidChefProjetReserve = false"
          >Annuler</v-btn>
          <v-btn color="green darken-1" flat="flat" @click.native="valideReserve()">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  MODAL CONFORMATION CHEF PROJET RESERVE-->

    <!--  MODAL CONFORMATION RESERVE -->
    <v-dialog v-model="dialogValidChef" max-width="380">
      <v-card>
        <v-card-title class="headline">Confirmation des travaux selectionnés</v-card-title>
        <v-card-text>
          En cliquant sur valider, en tant que responsable, vous confirmez que les travaux ont été correctement realisés.
          <p v-if="type ==1">La reserve sera soumise au chef projet pour la validation</p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialogValidChef = false">Annuler</v-btn>
          <v-btn color="green darken-1" flat="flat" @click.native="validerReserve()">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  MODAL CONFORMATION TRAVAUX TACHE RESERVE-->


    <!--  MODAL REFUSER TRAVAUX TACHE RESERVE -->
    <v-dialog v-model="dialogRefusReserve" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">Travaux de {{reserveSelect.libTache}}</v-card-title>
        <v-card-text>
          <v-flex xs12>
            <el-form label-position="top" :inline="true" class="demo-form-inline">
              <v-layout wrap>
                <v-flex xs12>
                  <el-form-item label="Commentaire" style="width:100%">
                    <el-input
                      type="textarea"
                      :rows="4"
                      id="commentaire"
                      placeholder="Commentaire"
                      v-model="formFinTrx.com"
                      style="width:100%"
                    ></el-input>
                  </el-form-item>
                </v-flex>
              </v-layout>
              <v-flex md3>
                <v-avatar :tile="true" size="140px" height="120px" color="grey lighten-4">
                  <img :src="imageTrx" alt="avatar" />
                </v-avatar>
                <v-layout row>
                  <input
                    name="fileTache"
                    type="file"
                    style="display:none"
                    ref="fileTache"
                    accept="image/*"
                    @change="onFileTachePicked"
                  />
                  <v-btn
                    color="primary"
                    class="white--text"
                    required
                    @click.native="$refs.fileTache.click()"
                  >
                    Image Travaux
                    <v-icon right dark>cloud_upload</v-icon>
                  </v-btn>
                </v-layout>
              </v-flex>
            </el-form>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click.native="dialogRefusReserve = false"
          >Annuler</v-btn>

          <v-btn
            color="green darken-1"
            flat="flat"
            :disabled="!formFinTrx.com"
            @click.native="refusTacheRapport()"
          >Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  MODAL REFUSER TRAVAUX TACHE RESERVE-->


  </div>
</template>

<script>
import Loading from "@/components/Loading";
export default {
  components: { Loading },
  name: "ListeReserve",
  props: {
    show: {
      type: Boolean
    },
    type: {
      type: Number, //0=>chef travaux // 1=> chef chantier, 2=>chef projet
      default: 0
    },
    listeReserveTrx: {
      type: Array
    }
  },
  data() {
    return {
      //data general
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      loading: false,
      dialogValidReserve: false,
      dialogReserveTache: false,
      detailReserve: [],
      disabledBtnTermine: true,
      multipleSelection: [],
      idReserve: null,
      //FILTRE
       listeProjet:[],
       listeChantier:[],
       BesoinsList: [],
       projetS: '',
       chantierS: '',
      dialogValidChef: false,
      etatReserve: 0, //0=>Trx en cours//1=>EN ATTENTE DE VALIDATION CHEF CHANTIER//2=> EN ATTENTE DE VALIDATION CHEF PROJET
      dialogValidChefProjetReserve: false,
      coutReserve: 0,
      dureeReserve: 0,
      tacheSelect: {},
      formFinTrx: {
        com:""
      },
      imageTrx: "/static/travaux.jpg",
      fileTache: [],
      etatRes: "",
      listeReserves: [],
      listeEtatReserve: [
        {
          value: 0,
          libelle: "TRAVAUX EN COURS"
        },
        {
          value: 1,
          libelle: "EN ATTENTE DE VALIDATION CHEF CHANTIER"
        },
        {
          value: 2,
          libelle: "EN ATTENTE DE VALIDATION CHEF PROJET"
        },
        {
          value: 3,
          libelle: "VALIDE"
        }
      ],
      dialogRefusReserve: false,
      reserveSelect: {
          libTache: ""
      }
    };
  },

  watch: {
    show : function(newValue, oldvalue){
                if(newValue == true){
                    //this.oldListTravaux = this.listeTrx;
                }
            },
    listeReserveTrx : function(newValue, oldvalue){
      this.listeReserves = this.listeReserveTrx;
    },
  },

  methods: {
     //FILTRE
    loadProjet ()
    {
      this.listeChantier.splice(0)
      this.chantierS = null
        let url = this.domaine + 'projet/index-projet-all'
        this.loading = true
        this.$http.get(url).then(response => {
            this.loading = false
                this.listeProjet = response.body.projet
        },errRep=>{
              this.loading = false
            this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
        })
    },
    loadChantier ()
      {
        if( (this.projetS == null || this.projetS == "undefined" || this.projetS == "")   ){
            this.listeReserves = this.listeReserveTrx;
          return ;
        }
        this.loading =  true
        let url = this.domaine + 'projet/'+ this.projetS +'/index/chantier'
        this.$http.get(url).then(response => {
            this.loading = false
            this.listeChantier = response.body.chantier
        },errRep=>{
              this.loading = false
            this.$message.error("Une erreur est survenue lors du chargement de la liste du chntier")
        })
    },
    filtrerChantier(){
        //this.oldListTravaux = this.listeTrx;
        let idChant = this.chantierS;
        this.listeReserves = this.listeReserveTrx.filter(function (item) {
        return item.idChant == idChant
        })
      },
    clearSelect(){
      //this.listeTrx = this.oldListTravaux;
       this.chantierS= '';
      this.projetS= '';
      this.chantierS= '';
      this.listeChantier.splice(0)
    },
    validerTacheRapport() {
      this.loading = true;
      let url = this.domaine + "reserve/tache/valide/" + this.idReserve;

      let data = new FormData();
      data.append("idUser", this.user.id);

      data.append("commentaire", this.formFinTrx.com);
      if (this.fileTache.length > 0) {
        data.append("fichierImage", this.fileTache, this.fileTache[name]);
      }

      this.$http.post(url, data).then(
        response => {
          this.dialogValidReserve = false;
          this.loading = false;
          this.$notify({
            title: "TACHE TERMINE",
            message: "Tache enregistrée avec succès",
            type: "success",
            position: "top-center"
          });
          this.$emit("reloadListeReserve");
          //this.loadDetailReserve(this.idReserve);
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Echec lors de la confirmation de l'execution des travaux"
          );
        }
      );
    },
     refusTacheRapport() {
      this.loading = true;

      let url = this.domaine + "reserve/tache/refuser/" + this.idReserve;

      let data = new FormData();
      data.append("idUser", this.user.id);

      data.append("commentaire", this.formFinTrx.com);

      if (this.fileTache.length >0) {
        data.append("fichierImage", this.fileTache, this.fileTache[name]);
      }

      this.$http.post(url, data).then(
        response => {
          this.dialogRefusReserve = false;
          this.loading = false;
          this.formFinTrx.com = "",
          this.imageTrx = "/static/travaux.jpg",

          this.$notify({
            title: "TACHE TERMINE",
            message: "Tache enregistrée avec succès",
            type: "success",
            position: "top-center"
          });
          this.$emit("reloadListeReserve");

        },
        error => {
          this.loading = false;
          this.$message.error(
            "Echec lors de la confirmation de l'execution des travaux"
          );
        }
      );
    },
    valideReserve() {
      this.loading = true;
      let data = new FormData();
      data.append("idUser", this.user.id);
      let url = "";
      if (this.type == 2) {

        url = this.domaine + "reserve/respoprojet/valider/" + this.idReserve;
      } else if (this.type == 1) {
        url = this.domaine + "reserve/respochantier/valider/" + this.idReserve;
      } else {
        return;
      }

      data.append("cout", this.coutReserve);
      data.append("duree", this.dureeReserve);

      this.$http.post(url, data).then(
        response => {
          this.dialogValidChef = false;
          this.dialogReserveTache = false;
          this.loading = false;
          this.$notify({
            title: "VALIDATION RESERVE",
            message: "Reserve validé avec succès",
            type: "success",
            position: "top-center"
          });
          this.dialogValidChefProjetReserve = false;
          this.$emit("reloadListeReserve");
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors de la validation de la reservation");
        }
      );
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      if (this.multipleSelection.length === 0) {
        this.disabledBtnTermine = true;
      } else {
        this.disabledBtnTermine = false;
      }
    },

    loadDetailReserve(idReserve) {
      this.loading = true;
      this.idReserve = idReserve;
      let url = this.domaine + "reserve/" + idReserve;
      this.$http.get(url).then(
        response => {
          this.detailReserve = response.body.reserve;
          //this.dialogReserveTache = true
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error("Echec lors du chargement des taches");
        }
      );
    },
    onFileTachePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      if (filename.lastIndexOf(".") <= 0) {
        return alert("Veuillez selectionner un  format de fichier valide ");
      }

      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.imageTrx = fileReader.result;
      });

      fileReader.readAsDataURL(files[0]);
      this.fileTache = files[0];
      console.log("file 0 ", files[0]);
    },
    filtrerEtat() {
      this.listeReserves = this.listeReserveTrx.filter(function(item) {
        return item.etatReserve == this.etatRes;
      }, this);
    },
    clearSelect() {
      this.listeReserves = this.listeReserveTrx;
    },

      resetForm(formName) {
        console.log("resetForm");
        this.formFinTrx.com = "";
        this.fileTache = [];
        this.imageTrx = "/static/travaux.jpg";
      },

    modalAjoutReserve() {}
  },

  mounted() {
    this.loadProjet();
    this.loadChantier();
    this.clearSelect();

  }

};
</script>




// WEBPACK FOOTER //
// src/components/rapport/ListeReserve.vue